import { isArray } from 'lodash'
import { insertLayer } from 'actions/insertLayer'
import { shiftItemsByAssetOnDrop } from '~/actions/layer'
import { deleteAssets, deleteEmptyLayers, setReference } from '~/actions/timeline'
import TimelineLayer from '../Layer'
import { AssetHistoryAction } from './AssetHistoryAction'
import { HistoryActionType } from './HistoryActionType'
import { getActionByAssetType } from '~/helpers/actions/getActionByAssetType'
import { setTimeCodeMode } from '~/actions/playback'
import { TIME_CODE_CONTAINER_LOCATION } from '~/config/constants/timecode'


export class AssetCreationAction extends AssetHistoryAction {

  constructor(payload, ...params) {
    super(HistoryActionType.AssetCreationAction, payload, ...params)
    const { layerData, deltaOnDrop, referenceFileData, timeCodeMode } = payload
    this._deltaOnDrop = deltaOnDrop
    this._timeCodeMode = timeCodeMode
    this._referenceFileData = referenceFileData
    this._layerData = layerData.map(({ isNewLayer, newLayer, newLayerIndex }) => {
      const timelineLayer = newLayer instanceof TimelineLayer
        ? newLayer
        : new TimelineLayer(newLayer)
      return {
        newLayer: timelineLayer,
        isNewLayer: Boolean(isNewLayer),
        newLayerIndex,
      }
    }).sort((a, b) => a.newLayerIndex - b.newLayerIndex)
  }

  get referenceFileData() {
    return this._referenceFileData
  }

  set referenceFileData(data) {
    this._referenceFileData = data
  }

  get timeCodeMode() {
    return this._timeCodeMode
  }

  set timeCodeMode(data) {
    this._timeCodeMode = data
  }

  get deltaOnDrop() {
    return this._deltaOnDrop
  }

  set deltaOnDrop(v) {
    this._deltaOnDrop = v
  }

  get layerData() {
    return this._layerData
  }

  set layerData(layerData) {
    this._layerData = layerData
  }

  * undo() {
    const { asset, deltaOnDrop } = this
    const sortedAssets = isArray(asset) ? asset : [ asset ]

    if (deltaOnDrop) {
      yield shiftItemsByAssetOnDrop({
        id: sortedAssets.map(asset => asset.id),
        layerId: sortedAssets[0].layerId,
        time: sortedAssets.at(-1).startTime,
        delta: -1 * deltaOnDrop,
      })
    }

    yield deleteAssets([ ...sortedAssets ])
    yield deleteEmptyLayers()
  }

  * redo() {
    const { asset, deltaOnDrop, referenceFileData, timeCodeMode } = this
    const sortedAssets = isArray(asset) ? asset : [ asset ]
    for (const { isNewLayer, newLayer, newLayerIndex } of this.layerData) {
      if (isNewLayer) {
        yield insertLayer({ index: newLayerIndex, layer: newLayer })
      }
    }

    if (deltaOnDrop) {
      yield shiftItemsByAssetOnDrop({
        id: sortedAssets.map(asset => asset.id),
        layerId: sortedAssets[0].layerId,
        time: sortedAssets[0].startTime,
        delta: deltaOnDrop,
      })
    }
    yield setReference(referenceFileData)
    yield setTimeCodeMode({
      mode: timeCodeMode,
      containerLocation: TIME_CODE_CONTAINER_LOCATION.TIMELINE,
    })
    yield {
      type: getActionByAssetType(sortedAssets[0]),
      payload: {
        asset: sortedAssets,
        layerData: this.layerData,
        deltaOnDrop,
      },
    }
  }

}
